/* NAP — Lightbox zoomabile per il Lookbook (click foto -> ingrandita + zoom/pan + prev/next).
   Si attiva sulle sezioni con [data-nap-lightbox]. Nessuna dipendenza. */
(function () {
  var overlay, imgEl, stage, els = [], idx = 0, scale = 1, tx = 0, ty = 0,
      dragging = false, sx = 0, sy = 0, built = false;

  function bigSrc(img) {
    var s = img.currentSrc || img.src || img.getAttribute('data-src') || '';
    return s.replace(/([?&])width=\d+/, '$1width=2000').replace(/([?&])height=\d+/, '$1');
  }
  function apply() {
    imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    imgEl.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
  }
  function reset() { scale = 1; tx = 0; ty = 0; apply(); }
  function zoomAt(factor) { scale = Math.min(5, Math.max(1, scale * factor)); if (scale === 1) { tx = 0; ty = 0; } apply(); }
  function show(i) {
    idx = (i + els.length) % els.length;
    reset();
    imgEl.src = bigSrc(els[idx]);
    imgEl.alt = els[idx].getAttribute('alt') || '';
  }
  function go(d) { show(idx + d); }
  function open(i) { if (!built) build(); show(i); overlay.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function close() { overlay.classList.remove('is-open'); document.documentElement.style.overflow = ''; reset(); }

  function build() {
    built = true;
    overlay = document.createElement('div');
    overlay.className = 'nap-lb';
    overlay.innerHTML =
      '<button class="nap-lb__close" aria-label="Chiudi">×</button>' +
      '<button class="nap-lb__nav nap-lb__nav--prev" aria-label="Precedente">‹</button>' +
      '<button class="nap-lb__nav nap-lb__nav--next" aria-label="Successiva">›</button>' +
      '<div class="nap-lb__stage"><img class="nap-lb__img" alt=""></div>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.nap-lb__img');
    stage = overlay.querySelector('.nap-lb__stage');
    overlay.querySelector('.nap-lb__close').addEventListener('click', close);
    overlay.querySelector('.nap-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    overlay.querySelector('.nap-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay || e.target === stage) close(); });
    imgEl.addEventListener('click', function (e) { e.stopPropagation(); if (scale > 1) reset(); else zoomAt(2.4); });
    imgEl.addEventListener('wheel', function (e) { e.preventDefault(); zoomAt(e.deltaY < 0 ? 1.2 : 1 / 1.2); }, { passive: false });
    imgEl.addEventListener('pointerdown', function (e) { if (scale <= 1) return; dragging = true; sx = e.clientX - tx; sy = e.clientY - ty; try { imgEl.setPointerCapture(e.pointerId); } catch (x) {} });
    imgEl.addEventListener('pointermove', function (e) { if (!dragging) return; tx = e.clientX - sx; ty = e.clientY - sy; apply(); });
    window.addEventListener('pointerup', function () { dragging = false; });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
    });
  }

  function init() {
    document.querySelectorAll('[data-nap-lightbox]').forEach(function (sec) {
      sec.querySelectorAll('.lookbook-tile__image, .lookbook-tile img').forEach(function (img) {
        if (img.closest('.nap-lb')) return;
        var myIndex = els.length;
        els.push(img);
        var target = img.closest('a') || img.closest('.lookbook-tile') || img;
        target.style.cursor = 'zoom-in';
        target.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(myIndex); });
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
